import { CircularProgress, Grid, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../../widgets';
import FechasPersonalizada from '../../../../widgets/FechasPersonalizada';
import SelectFieldMateriasComponent from '../../../control_estudios/materias/components/SelectFieldMaterias';
import { oneDocentesAction } from '../../docentes/DocentesAction';
import SelectFieldDocentesComponent from '../../docentes/components/SelectFieldDocentes';
import DetallesPlanEvaluacionComponent from '../../plan_evaluacion/plan_evaluacion/panel/components/DetallesPlanEvaluacion';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import {
  allAsistenciasAction,
  allEstudiantesAsistenciasAction,
} from '../AsistenciasAction';
import {
  PARAMS_ASISTENCIAS_DIARIAS,
  PLANEVA_ASISTENCIAS_DIARIAS,
} from '../AsistenciasReducer';

let intervalSearch = null;

const FiltrosAsistenciasComponent = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const asistenciasStore = Redux.useSelector((state) => state.asistencias);
  const docentesStore = Redux.useSelector((state) => state.docentes);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );

  const [openModalPlaneva, setOpenModalPlaneva] = React.useState(false);
  const [loadingPlan, setLoadingPlan] = React.useState(false);
  const [materias, setMaterias] = React.useState([]);
  const [secciones, setSecciones] = React.useState([]);

  const [bloqueSelect, setBloqueSelect] = React.useState(null);

  const getData = async (object) => {
    const payload = {
      ...asistenciasStore.params,
      ...object,
    };
    dispatch({
      type: PARAMS_ASISTENCIAS_DIARIAS,
      payload,
    });
    await allAsistenciasAction(dispatch, payload);
  };

  React.useEffect(() => {
    const fetchData = async () => {
      if (
        asistenciasStore.params.idMateria &&
        asistenciasStore.params.idSeccion &&
        asistenciasStore.planEvaluacion
      ) {
        const payload = {
          ...asistenciasStore.params,
          fechaInicio: asistenciasStore.planEvaluacion.fechaBloque.desde,
          fechaFinal: asistenciasStore.planEvaluacion.fechaBloque.hasta,
        };
        dispatch({ type: PARAMS_ASISTENCIAS_DIARIAS, payload });
        await allEstudiantesAsistenciasAction(dispatch, payload);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    asistenciasStore.params.idMateria,
    asistenciasStore.params.idSeccion,
    asistenciasStore.planEvaluacion,
  ]);

  React.useEffect(() => {
    setMaterias([]);
    setSecciones([]);
    if (asistenciasStore.params.idDocente) {
      setMaterias(docentesStore.activo.materias);
      setSecciones(docentesStore.activo.secciones);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asistenciasStore.params.idDocente]);

  React.useEffect(() => {
    if (bloqueSelect) {
      setLoadingPlan(true);
      const planEva = planEvaluacionStore.all.find(
        (el) =>
          el.seccion.id === asistenciasStore.params.idSeccion &&
          el.fechaBloque.bloquePedagogico.id === bloqueSelect &&
          el.materia.id === asistenciasStore.params.idMateria,
      );
      dispatch({ type: PLANEVA_ASISTENCIAS_DIARIAS, payload: planEva });
      setTimeout(() => {
        setLoadingPlan(false);
      }, 800);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bloqueSelect, asistenciasStore.params.idSeccion]);

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>

      <FechasPersonalizada
        mdStart={12}
        mdEnd={12}
        startDate={asistenciasStore.params.desde}
        endDate={asistenciasStore.params.hasta}
        onStart={(desde) => {
          if (!desde) return;
          clearTimeout(intervalSearch);
          intervalSearch = setTimeout(async () => {
            getData({ desde });
          }, 800);
        }}
        onEnd={(hasta) => {
          if (!hasta) return;
          clearTimeout(intervalSearch);
          intervalSearch = setTimeout(async () => {
            getData({ hasta });
          }, 800);
        }}
      />

      {(loginStore.isAdmin || loginStore.isRoot) && (
        <Grid item md={12}>
          <SelectFieldDocentesComponent
            value={asistenciasStore.params.idDocente}
            onChange={async (idDocente) => {
              await oneDocentesAction(dispatch, idDocente);
              getData({ idDocente });
            }}
          />
        </Grid>
      )}
      <Grid item md={12}>
        <SelectFieldMateriasComponent
          value={asistenciasStore.params.idMateria?.toString() ?? ''}
          data={materias.length > 0 ? materias : null}
          onChange={(idMateria) => getData({ idMateria })}
        />
      </Grid>

      <Grid item md={12}>
        <SelectFieldSeccionesComponent
          value={asistenciasStore.params.idSeccion}
          isAll={true}
          data={secciones.length > 0 ? secciones : null}
          onChange={(idSeccion) => getData({ idSeccion })}
        />
      </Grid>
      {/* <Grid item md={12}>
        <SelectFieldBloquesPedagogicosComponent
          value={asistenciasStore.params.idBloquePedagogico}
          onChange={(bloquePedagogico) => {
            setBloqueSelect(bloquePedagogico);
          }}
        />
      </Grid> */}
      <Grid item md={12} sx={{ display: 'flex' }}>
        {asistenciasStore.planEvaluacion &&
          (loadingPlan ? (
            <CircularProgress size="1.5rem" />
          ) : (
            <Stack direction="row">
              <Typography sx={{ mr: 4 }}>
                <strong>Fecha de inicio: </strong>
                {asistenciasStore.planEvaluacion.fechaBloque.desde}
              </Typography>
              <Typography>
                <strong>Fecha final: </strong>
                {asistenciasStore.planEvaluacion.fechaBloque.hasta}
              </Typography>
            </Stack>
          ))}
      </Grid>
      <ModalComponent
        id="modalFormPlanEvaluacion"
        title={`Plan de evaluación`}
        open={openModalPlaneva}
        maxWidth="lg"
        onClose={() => setOpenModalPlaneva(!openModalPlaneva)}
      >
        <DetallesPlanEvaluacionComponent
          planEvaluacion={asistenciasStore.planEvaluacion}
        />
      </ModalComponent>
    </Grid>
  );
};

export default FiltrosAsistenciasComponent;
